import React from "react";
import { Form } from "react-bootstrap";
import { TParamOption } from "../../../../../api/endpoints/SubsetOption";
import Footnote from "../../../Footnote";
import FormError from "../../../FormError";
import ParamsSelector from "../../../ParamsSelector";
import { FormikProductFormField, TFormErrorMessage } from "../../index";

interface Props extends FormikProductFormField {
  spec: TParamOption;
}

const ParametersField = (props: Props) => {
  const { formik, spec } = props;

  return (
    <Form.Group controlId="param">
      <Form.Label>Parameters</Form.Label>
      <ParamsSelector
        values={formik.values.param}
        spec={spec}
        onChange={values => formik.setFieldValue('param', values)}
      />

      <FormError
        message={formik.errors.param as TFormErrorMessage}
        when={formik.touched.param && Boolean(formik.errors.param)}
      />

      <Footnote text={spec.footnote} />
    </Form.Group>
  );
}

export default ParametersField;
